import { render, staticRenderFns } from "./AccidentReport.vue?vue&type=template&id=8d7811b0&"
import script from "./AccidentReport.vue?vue&type=script&lang=js&"
export * from "./AccidentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports